import template from './sw-order-line-items-grid.html.twig';
import './sw-order-line-items-grid.scss';

const { Component } = Shopware;

/**
 * Extends the core admin order detail's line-item grid with a small badge
 * identifying which line items were discounted through Ultimate Cart's
 * Cross-Sell rule builder — the merchant-facing "how do I verify this
 * product came from cross-sell" signal, read from the payload markers
 * CrossSellDiscountCartProcessor sets (sellopsUcCrossSellDiscount /
 * sellopsUcCrossSellDiscountPercent), which survive from cart into the
 * placed order's order_line_item.payload unchanged.
 *
 * Deliberately admin-only: the storefront/checkout product title is never
 * touched (see CrossSellDiscountCartProcessor::applyDiscount()) — this is
 * purely an admin order-review affordance.
 */
Component.override('sw-order-line-items-grid', {
    template,
});
